// Action Types
export const UPDATE_RISK_SCORE_CHARGES_REQUEST = "UPDATE_RISK_SCORE_CHARGES_REQUEST";
export const UPDATE_RISK_SCORE_CHARGES_SUCCESS = "UPDATE_RISK_SCORE_CHARGES_SUCCESS";
export const UPDATE_RISK_SCORE_CHARGES_FAILURE = "UPDATE_RISK_SCORE_CHARGES_FAILURE";
export const UPDATE_RISK_SCORE_CHARGES_RESET = "UPDATE_RISK_SCORE_CHARGES_RESET";
// Action Creators
export const updateRiskScoreChargesRequest = (payload) => ({
    type: UPDATE_RISK_SCORE_CHARGES_REQUEST,
    payload,
});
export const updateRiskScoreChargesSuccess = (payload) => ({
    type: UPDATE_RISK_SCORE_CHARGES_SUCCESS,
    payload,
});
export const updateRiskScoreChargesFailure = (payload) => ({
    type: UPDATE_RISK_SCORE_CHARGES_FAILURE,
    payload,
});
export const updateRiskScoreChargesReset = () => ({
    type: UPDATE_RISK_SCORE_CHARGES_RESET,
});
